import React, { Component } from "react";

class Loader extends Component {
  state = {};
  render() {
    if (this.props.loaded) {
      return <div />;
    }
    return (
      <div className="spinner">
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader.jsx